// frontend/src/utils/api.js
const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

function getCsrfToken() {
    const match = document.cookie.match(/csrf_token=([^;]+)/);
    return match ? match[1] : "";
}

export async function apiFetch(url, options = {}) {
    const headers = { ...options.headers };

    // Add CSRF token for mutating requests
    const method = (options.method || "GET").toUpperCase();
    if (method !== "GET" && method !== "HEAD") {
        headers["X-CSRF-Token"] = getCsrfToken();
    }

    // Add Content-Type for JSON bodies (but not FormData)
    if (options.body && !(options.body instanceof FormData)) {
        headers["Content-Type"] = headers["Content-Type"] || "application/json";
    }

    const response = await fetch(url, {
        credentials: "include",
        ...options,
        headers,
    });

    // El formulario necesita recibir el 401 para mostrar credenciales incorrectas.
    const isLogin = new URL(url, window.location.origin).pathname === "/api/auth/login";
    if (response.status === 401 && !isLogin) {
        // Don't redirect if we're already on login page or checking auth
        if (!window.location.pathname.includes("/login")) {
            window.location.href = "/login";
        }
        throw new Error("Not authenticated");
    }

    return response;
}

export { API };
